// Cognito Configuration for Agent Frontend
// This file configures AWS Amplify for authentication with Azure AD SSO
// Environment variables are injected by Terraform via Amplify

// Use environment variable if set, otherwise use current origin
const getRedirectUrl = (envVar) => {
  const envValue = process.env[envVar];
  // Only use env variable if it's set and not empty
  if (envValue && envValue.trim() !== '') {
    return [envValue];
  }
  // Default to current origin
  return [window.location.origin];
};

export const authConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_COGNITO_DOMAIN,
          scopes: ['aws.cognito.signin.user.admin', 'openid', 'email', 'profile', 'phone'],
          redirectSignIn: getRedirectUrl('REACT_APP_REDIRECT_SIGN_IN'),
          redirectSignOut: getRedirectUrl('REACT_APP_REDIRECT_SIGN_OUT'),
          responseType: 'code',
          providers: [{ custom: process.env.REACT_APP_COGNITO_IDP || 'AzureAD' }]
        }
      }
    }
  }
};

// Required group for Agent frontend
export const REQUIRED_GROUP = 'Agents';

// Azure AD provider name (from Terraform)
export const AZURE_PROVIDER = process.env.REACT_APP_COGNITO_IDP || 'AzureAD';